// extracted by mini-css-extract-plugin
module.exports = {"switch":"ThemeSwitch_switch__1dVzr","slider":"ThemeSwitch_slider__2Q9Dz","round":"ThemeSwitch_round__3SU5P"};